import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { MODULES } from "./constants";
import { createReduxStore } from "./redux/store";
import withSectionToggle from "./HOCs/withSectionToggle";

// TODO: move up as much as possible
// each string object afterwards has a .capitalize() property
Object.defineProperty(String.prototype, "capitalize", {
  value: function () {
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  enumerable: false
});

const store = createReduxStore("marketing");
const Marketing = (props) => {
  // prepare modules array with all necessary props
  const modules = props.params.modules.map(({ moduleName, ...rest }) => ({
    ...rest,
    ...MODULES[moduleName],
    moduleName
  }));

  return (
    <Provider store={store}>
      {modules.map(({ moduleName, component, ...rest }) => {
        const Module = withSectionToggle(component, { ...rest, moduleName, params: props });
        return <Module key={moduleName} />;
      })}
    </Provider>
  );
};

Marketing.propTypes = { props: PropTypes.object };

export default Marketing;
